import type { ReactElement, ReactNode } from 'react';
import styles from './Badge.module.scss';

export type Tone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'secondary';

export interface BadgeProps {
  tone?: Tone;
  /** Цвет точки из данных (цвет статуса блога, POST-UC-9), а не из темы. */
  color?: string;
  title?: string;
  children: ReactNode;
}

/** Текст для подсказки обрезанного бейджа: только если он строка или число. */
function plainText(children: ReactNode): string | undefined {
  return typeof children === 'string' || typeof children === 'number' ? String(children) : undefined;
}

/** Бейдж — одна строка; не помещается — многоточие и полный текст в подсказке (SYS-UC-11.CC-1). */
export function Badge({ tone = 'neutral', color, title, children }: BadgeProps): ReactElement {
  return (
    <span className={`${styles.badge} ${styles[tone]}`} title={title ?? plainText(children)}>
      {color ? <span className={styles.dot} style={{ background: color }} aria-hidden="true" /> : null}
      <span className={styles.text}>{children}</span>
    </span>
  );
}

/** Хештег поста: одна строка, длинный обрезается многоточием (SYS-UC-11.CC-1). */
export function Tag({ children }: { children: string }): ReactElement {
  return (
    <span className={styles.tag} title={`#${children}`}>
      #{children}
    </span>
  );
}
